import React from 'react';
import { Header } from 'semantic-ui-react';

const style = { fontWeight: 'normal', fontSize: '1em' };

const ColorCell = ({
  cellData,
  columnData,
  columnIndex,
  dataKey,
  isScrolling,
  rowData,
  rowIndex,
}) => {
  if (!cellData) {
    return <div />;
  }
  const { value } = cellData || '';
  return (
    <Header style={style} size="small" textAlign="right">
      {value}
    </Header>
  );
};

export default ColorCell;



// WEBPACK FOOTER //
// ./src/containers/Markets/components/MarketsTable/components/MarketsTableComponent/components/NoColorCell/index.jsx